import { useTranslation } from 'react-i18next';
import { Tolerance, Nullable, getDimensionUnit, ThicknessType, TranslateFunc } from '@steelbuy/ts-shared';
import { Card, CardContentAttributes, CardContentAttributesItem, CardLayout } from '@steelbuy/ui-primitive';
import { getThicknessText, shouldShowTolerance } from '@steelbuy/util';

interface ListingDetailsDimensionsProps {
    thickness: Nullable<string | number>;
    tolerance?: Nullable<Tolerance>;
    width: Nullable<string | number>;
    length?: Nullable<string | number>;
    gauge?: Nullable<string | number>;
    thicknessType?: ThicknessType;
}

export const ListingDetailsDimensions = ({
    length,
    thickness,
    tolerance,
    width,
    gauge,
    thicknessType,
}: ListingDetailsDimensionsProps) => {
    const { t } = useTranslation(['domainModel']);

    return (
        <Card isClickable={false}>
            <CardLayout>
                <CardContentAttributes header={t('domainModel:material.dimensions.name')}>
                    <CardContentAttributesItem
                        label={t('domainModel:material.dimensions.thickness')}
                        value={thickness ? getThicknessText(thickness, thicknessType, t as TranslateFunc, false) : '-'}
                    />
                    <CardContentAttributesItem
                        label={t('domainModel:material.dimensions.width')}
                        value={
                            width
                                ? t(`domainModel:material.dimensions.units.${getDimensionUnit()}.labelWithValue`, {
                                      value: `${width} `,
                                  })
                                : '-'
                        }
                    />
                    {length !== undefined && (
                        <CardContentAttributesItem
                            label={t('domainModel:material.dimensions.length')}
                            value={
                                length
                                    ? t(`domainModel:material.dimensions.units.${getDimensionUnit()}.labelWithValue`, {
                                          value: `${length} `,
                                      })
                                    : '-'
                            }
                        />
                    )}
                    {gauge !== undefined && (
                        <CardContentAttributesItem
                            label={t('domainModel:material.gauge.name')}
                            value={gauge?.toString() ?? ''}
                        />
                    )}
                    {tolerance && shouldShowTolerance(tolerance) && (
                        <CardContentAttributesItem
                            label={t('domainModel:material.tolerance.name')}
                            value={tolerance ? t(`domainModel:material.tolerance.value.${tolerance}`) : '-'}
                        />
                    )}
                </CardContentAttributes>
            </CardLayout>
        </Card>
    );
};
